import flatten from 'lodash.flatten';
import { groupNodeEntities } from './helpers';
import injectBanner from '../../inject-banner';

export default function getBannersForNodes(entitiesSet, banner) {
  const groups = groupNodeEntities(entitiesSet, banner);
  const nodesWithBanner = groups
    .map((chunk, index) => {
      const key = `${banner.adunit}-${index}`;
      const interval = chunk.length + 1;

      return injectBanner(chunk, { ...banner, key, interval });
    })
    .map(flatten);

  return nodesWithBanner;
}
